
  import {createObjectFromQueryString} from '@/helper/QueryHelper';
  import {debounce} from 'lodash/function';
  import gql from 'graphql-tag';
  import eventCategoriesWithPublishedEvents from '@/apollo/queries/event/eventCategoriesWithPublishedEvents';

  export default {
    name: 'EventFilter',
    props: {
      searchTerm: {
        type: String,
        required: false,
        default: '',
      },
      contentScope: {
        type: String,
        required: false,
        default: 'promotionbasis_candidate',
      },
      triggerResetFilter: {
        type: Boolean,
        required: false,
        default: false,
      },
      filterParams: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data() {
      return {
        search_term_filter: null,
        search_city_filter: null,
        disabled: false,
        datePeriodStart: null,
        datePeriodEnd: null,
        categories_filter: [],
        eventCategories: [],
      };
    },
    apollo: {
      eventCategories: {
        // Name der Property hier auch aktualisiert
        query: eventCategoriesWithPublishedEvents,
        variables() {
          return {
            scope: this.contentScope,
            date_today: this.$dayjs(new Date()).format('YYYY-MM-DD'),
          };
        },
        result({data}) {
          this.eventCategories = data.eventCategories.filter(
            (category) => category.events.length > 0
          );
          if (this.eventCategories.length > 0) {
            this.fetchEventsCounts();
          }
        },
      },
    },
    computed: {
      formattedPeriodEnd() {
        return this.datePeriodEnd
          ? this.$dayjs(this.datePeriodEnd).format('DD.MM.YYYY')
          : null;
      },
      formattedPeriodStart() {
        return this.datePeriodStart
          ? this.$dayjs(this.datePeriodStart).format('DD.MM.YYYY')
          : null;
      },
    },

    watch: {
      triggerResetFilter: function (val) {
        if (val) {
          this.resetFilterValues();
        }
      },
      '$route.query': function () {
        this.setupTheSearch();
      },
    },
    created() {
      this.applyFilterWithThrottle = debounce(() => {
        this.applyFilter(true);
      }, 2000);
      this.search_term_filter = this.filterParams
        ? this.filterParams.search_term
        : '';
      this.search_city_filter = this.filterParams
        ? this.filterParams.search_city
        : '';
      this.datePeriodStart = this.filterParams
        ? this.filterParams.date_from
        : null;
      this.datePeriodEnd = this.filterParams
        ? this.filterParams.date_until
        : null;
      this.categories_filter = this.filterParams
        ? this.filterParams.categories
        : [];
      this.setupTheSearch();
    },
    beforeDestroy() {
      if (this.applyFilterWithThrottle) {
        this.applyFilterWithThrottle.cancel();
      }
    },
    methods: {
      fetchEventsCounts() {
        const categorySlugs = this.eventCategories.map((cat) => cat.slug);
        const query = this.buildQuery(categorySlugs);
        this.$apollo
          .query({
            query,
            variables: this.buildVariables(categorySlugs),
          })
          .then((result) => {
            this.extractCountsAndMerge(result);
          });
      },
      buildQuery(slugs) {
        let query =
          'query countEventsByEachCategory($scope: String!, $today: String!, ';
        query += slugs
          .map((slug, index) => `$slug${index + 1}: String!`)
          .join(', ');
        query += ') { ';
        query += slugs
          .map(
            (slug, index) => `
        countSlug${index + 1}: eventsConnection(where: {
          _and: [
            {scope_contains: $scope},
            {published_at_null: false},
            {event_category: {slug: $slug${index + 1}}},
            {date_until_gt: $today}
          ]
        }) {
          aggregate {
            count
          }
        }
      `
          )
          .join('');
        query += '}';
        return gql`
          ${query}
        `;
      },
      buildVariables(slugs) {
        const today = this.$dayjs(new Date()).format('YYYY-MM-DD');
        const variables = {scope: this.contentScope, today: today};
        slugs.forEach((slug, index) => {
          variables[`slug${index + 1}`] = slug;
        });
        return variables;
      },
      extractCountsAndMerge(result) {
        const counts = Object.keys(result.data).map((key) => {
          return result.data[key].aggregate.count;
        });

        this.eventCategories = this.eventCategories.map((category, index) => {
          return {...category, eventCount: counts[index] || 0};
        });
      },
      closeMenu(menuRef, date) {
        this.applyFilter(true);
        this.$refs[menuRef].save(date);
      },
      applyFilter() {
        const filterObj = {
          search_term: this.search_term_filter,
          search_city: this.search_city_filter,
          categories: this.categories_filter,
        };
        if (this.datePeriodStart) {
          filterObj.date_from = this.datePeriodStart;
        }
        if (this.datePeriodEnd) {
          filterObj.date_until = this.datePeriodEnd;
        }
        this.$emit('event-listing-filter', filterObj);
      },
      setupTheSearch() {
        const filterValues = createObjectFromQueryString(this.$route.query);
        if (filterValues['search']) {
          this.search_term_filter = filterValues['search'];
        } else {
          this.search_term_filter = null;
        }
        if (filterValues['city']) {
          this.search_city_filter = filterValues['city'];
        } else {
          this.search_city_filter = null;
        }
        if (filterValues['datePeriodStart']) {
          this.datePeriodStart = filterValues['datePeriodStart'];
        } else {
          this.datePeriodStart = null;
        }
        if (filterValues['datePeriodEnd']) {
          this.datePeriodEnd = filterValues['datePeriodEnd'];
        } else {
          this.datePeriodEnd = null;
        }
        if (filterValues['category[]']) {
          this.categories_filter = filterValues['category[]'][0].split(',');
        } else {
          this.categories_filter = [];
        }
      },
      resetFilterValues() {
        this.search_term_filter = null;
        this.search_city_filter = null;
        this.datePeriodStart = null;
        this.datePeriodEnd = null;
        this.categories_filter = [];
        this.$emit('event-listing-filter-reset');
      },
    },
  };
